<template>
    <div>
        <v-row no-gutters class="mb-5">
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    iSmart
                </h1>
            </v-col>
            <v-col cols="6" class="text-right">
                <v-btn
                    rounded
                    color="amber"
                    small
                    @click="get_dialog_history()"
                >
                    <v-icon small class="mr-1"> mdi-magnify </v-icon>
                    History
                </v-btn>
            </v-col>
        </v-row>
        <template>
            <v-row>
                <v-col cols="3" v-if="data_zone.length != 1">
                    <v-select
                        class="pr-3"
                        :items="data_zone"
                        v-model="form_search.zone"
                        outlined
                        dense
                        @change="get_branch()"
                    >
                        <template v-slot:label>
                            <v-icon
                                small
                                class="mb-1"
                                style="vertical-align: middle"
                            >
                                mdi-filter
                            </v-icon>
                            Filter Zone
                        </template>
                    </v-select>
                    <!-- <v-select
                        v-if="data_zone.length == 1"
                        class="pr-3"
                        :items="data_zone"
                        v-model="form_search.zone"
                        disabled
                        label="Disabled"
                    ></v-select> -->
                </v-col>

                <v-col cols="3" v-if="form_search.zone != 0">
                    <v-progress-linear
                        indeterminate
                        color="cyan"
                        class="mt-10"
                        v-if="
                            data_branch !== undefined &&
                                data_branch &&
                                data_branch.length == 0
                        "
                    ></v-progress-linear>
                    <v-select
                        v-else
                        class="pr-3"
                        :items="data_branch"
                        v-model="form_search.branch"
                        item-text="branch_name"
                        item-value="branch_id"
                        menu-props="auto"
                        outlined
                        dense
                        @change="get_status(), get_data('All')"
                    >
                        <template v-slot:label>
                            <v-icon
                                small
                                class="mb-1"
                                style="vertical-align: middle"
                            >
                                mdi-filter
                            </v-icon>
                            Filter Branch
                        </template>
                    </v-select>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        x-small
                        fab
                        v-if="
                            (form_search.zone != 0 &&
                                form_search.zone !== undefined) ||
                                form_search.zone != ''
                        "
                        @click="reset()"
                    >
                        <v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                </v-col>
            </v-row>

            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    class="cur-p"
                    v-if="form_search.zone != '' && form_search.branch != ''"
                >
                    <v-card @click="get_data('All')">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <b style="font-size:15px;">All</b>
                            </v-list-item-content>
                            <v-btn
                                elevation="0"
                                fab
                                dark
                                small
                                :color="
                                    chk_active_all === 1
                                        ? 'cyan accent-3'
                                        : 'grey lighten-1'
                                "
                                >{{ all_sum }}</v-btn
                            >
                        </v-list-item>
                        <v-system-bar
                            :height="4"
                            dark
                            :color="
                                chk_active_all === 1 ? 'cyan accent-3' : 'white'
                            "
                        >
                        </v-system-bar>
                    </v-card>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    class="cur-p"
                    v-for="(rowSum, indexSum) in data_status"
                    :key="indexSum"
                >
                    <v-card @click="get_data(rowSum.status, indexSum)">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <b style="font-size:15px;">{{
                                    rowSum.status
                                }}</b>
                            </v-list-item-content>
                            <v-btn
                                elevation="0"
                                fab
                                dark
                                small
                                :color="
                                    indexSum === chk_active_btn
                                        ? 'cyan accent-3'
                                        : 'grey lighten-1'
                                "
                                >{{ rowSum.num_cases }}</v-btn
                            >
                        </v-list-item>
                        <v-system-bar
                            :height="4"
                            dark
                            :color="
                                indexSum === chk_active_btn
                                    ? 'cyan accent-3'
                                    : 'white'
                            "
                        >
                        </v-system-bar>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <v-row
            v-if="
                form_search.branch != '' &&
                    form_search.zone != '' &&
                    form_search.status != ''
            "
        >
            <v-col cols="12">
                <v-simple-table class="table-inv">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center" width="5%">
                                    #
                                </th>
                                <th class="text-center">
                                    Zone / Engineer
                                </th>
                                <th
                                    class="text-center"
                                    v-if="form_search.status == 'All'"
                                >
                                    Status
                                </th>
                                <th class="text-center">
                                    Num Cases
                                </th>
                                <th class="text-center">
                                    Views
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    colspan="6"
                                    v-if="data_table && data_table.length === 0"
                                >
                                    <v-progress-linear
                                        indeterminate
                                        color="cyan"
                                    ></v-progress-linear>
                                </td>
                            </tr>
                            <tr
                                v-if="
                                    data_table &&
                                        data_table.length === 0 &&
                                        chk_load_data != true
                                "
                            >
                                <td colspan="6" class="text-center">
                                    no results found
                                </td>
                            </tr>

                            <tr v-for="(row, index) in data_table" :key="index">
                                <td class="text-center">{{ index + 1 }}</td>
                                <td class="text-left">
                                    {{ row.branch_name }} / {{ row.ce_name }}
                                </td>
                                <td
                                    class="text-left"
                                    v-if="form_search.status == 'All'"
                                >
                                    {{ row.ce_update_status }}
                                </td>
                                <td class="text-center">
                                    {{ row.cases }}
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        fab
                                        x-small
                                        dark
                                        elevation="1"
                                        @click="
                                            viewdata(
                                                row.ce_update_status,
                                                row.emp_id,
                                                row.branch_id
                                            )
                                        "
                                    >
                                        <v-icon
                                            >mdi-format-list-bulleted-square</v-icon
                                        >
                                    </v-btn>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
        <template>
            <v-row justify="center">
                <v-dialog
                    v-model="dialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card>
                        <v-toolbar dark color="primary">
                            <v-btn icon dark @click="dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                                <v-btn
                                    dark
                                    text
                                    v-if="
                                        readviewcase.length != data_view.length
                                    "
                                    disabled
                                    >Save</v-btn
                                >
                                <v-btn
                                    dark
                                    text
                                    v-else
                                    @click="
                                        save(
                                            data_view[0].ce_update_status,
                                            data_view[0].engineer
                                        )
                                    "
                                    >Save</v-btn
                                >
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-list three-line subheader>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-row>
                                        <v-col cols="12">
                                            <template>
                                                <div>
                                                    <!-- <div
                                                        class="text-center d-flex pb-4"
                                                    >
                                                        <v-btn @click="all">
                                                            All
                                                        </v-btn>

                                                        <v-btn @click="none">
                                                            none
                                                        </v-btn>
                                                    </div> -->

                                                    <v-expansion-panels
                                                        v-model="panel"
                                                        focusable
                                                    >
                                                        <v-expansion-panel
                                                            v-for="(item,
                                                            i) in data_view"
                                                            :key="i"
                                                        >
                                                            <v-expansion-panel-header
                                                                v-if="
                                                                    readviewcase.includes(
                                                                        i
                                                                    )
                                                                "
                                                                @click="
                                                                    readcasae(i)
                                                                "
                                                                style="color:blue;font-weight:bold;"
                                                            >
                                                                {{
                                                                    item.case_id
                                                                }}
                                                                |
                                                                {{
                                                                    item.wonumber
                                                                }}</v-expansion-panel-header
                                                            >
                                                            <v-expansion-panel-header
                                                                v-else
                                                                @click="
                                                                    readcase(i)
                                                                "
                                                                style="color:black;font-weight:bold;"
                                                            >
                                                                {{
                                                                    item.case_id
                                                                }}
                                                                |
                                                                {{
                                                                    item.wonumber
                                                                }}</v-expansion-panel-header
                                                            >
                                                            <v-expansion-panel-content>
                                                                <v-row>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="6"
                                                                    >
                                                                        <b>
                                                                            Case
                                                                            Title
                                                                            :
                                                                        </b>
                                                                        <span
                                                                            class="fix-color"
                                                                            >{{
                                                                                item.case_title
                                                                            }}</span
                                                                        >
                                                                    </v-col>

                                                                    <v-col
                                                                        cols="12"
                                                                        md="6"
                                                                    >
                                                                        <b
                                                                            >Case
                                                                            ID :
                                                                        </b>
                                                                        <span
                                                                            class="fix-color"
                                                                            >{{
                                                                                item.case_id
                                                                            }}</span
                                                                        >
                                                                        <v-chip
                                                                            style="margin-left:10px;"
                                                                            @click="
                                                                                doCopy(
                                                                                    item.case_id
                                                                                )
                                                                            "
                                                                            small
                                                                            class="mr-2 mb-2 success"
                                                                        >
                                                                            <v-avatar
                                                                                left
                                                                            >
                                                                                <v-icon
                                                                                    small
                                                                                    color="white"
                                                                                    >mdi-clipboard-file-outline</v-icon
                                                                                > </v-avatar
                                                                            ><label
                                                                                style="color:white;"
                                                                                >Copy
                                                                                Case
                                                                                ID</label
                                                                            >
                                                                        </v-chip>

                                                                        <ViewCdax
                                                                            caseid:item.case_id
                                                                        />
                                                                    </v-col>

                                                                    <v-col
                                                                        cols="12"
                                                                        md="6"
                                                                        style="margin-top:-15px;"
                                                                    >
                                                                        <b>
                                                                            Site
                                                                            Name
                                                                            :
                                                                        </b>
                                                                        <span
                                                                            class="fix-color"
                                                                            >{{
                                                                                item.site_name
                                                                            }}</span
                                                                        ></v-col
                                                                    >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="6"
                                                                        style="margin-top:-15px;"
                                                                    >
                                                                        <b
                                                                            >Wo
                                                                            Number
                                                                            :
                                                                        </b>
                                                                        <span
                                                                            class="fix-color"
                                                                            >{{
                                                                                item.wonumber
                                                                            }}</span
                                                                        >
                                                                        <v-chip
                                                                            v-if="
                                                                                item.wonumber !=
                                                                                    null
                                                                            "
                                                                            style="margin-left:10px;"
                                                                            @click="
                                                                                doCopy(
                                                                                    item.wonumber
                                                                                )
                                                                            "
                                                                            small
                                                                            class="mr-2 mb-2 primary"
                                                                        >
                                                                            <v-avatar
                                                                                left
                                                                            >
                                                                                <v-icon
                                                                                    small
                                                                                    color="white"
                                                                                    >mdi-clipboard-file-outline</v-icon
                                                                                > </v-avatar
                                                                            ><label
                                                                                style="color:white;"
                                                                                >Copy
                                                                                Wo
                                                                                Number</label
                                                                            >
                                                                        </v-chip>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="6"
                                                                        style="margin-top:-15px;"
                                                                        ><b
                                                                            >Engineer
                                                                            :
                                                                        </b>
                                                                        <span
                                                                            class="fix-color"
                                                                            >{{
                                                                                item.engineer_name
                                                                            }}</span
                                                                        ></v-col
                                                                    >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="6"
                                                                        style="margin-top:-15px;"
                                                                    >
                                                                        <b
                                                                            >Onsite
                                                                            Date
                                                                            : </b
                                                                        ><span
                                                                            class="fix-color"
                                                                            >{{
                                                                                item.onsite_at
                                                                            }}</span
                                                                        >
                                                                    </v-col>

                                                                    <v-col
                                                                        cols="12"
                                                                        md="4"
                                                                    >
                                                                        <v-textarea
                                                                            outlined
                                                                            rows="4"
                                                                            readonly
                                                                            v-model="
                                                                                item.lognote
                                                                            "
                                                                            label="Lognote..."
                                                                        ></v-textarea>
                                                                    </v-col>

                                                                    <v-col
                                                                        cols="12"
                                                                        md="4"
                                                                    >
                                                                        <v-textarea
                                                                            outlined
                                                                            rows="4"
                                                                            readonly
                                                                            v-model="
                                                                                item.cdax_log
                                                                            "
                                                                            label="CDAX Log..."
                                                                        ></v-textarea>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="4"
                                                                    >
                                                                        <v-textarea
                                                                            outlined
                                                                            rows="4"
                                                                            v-model="
                                                                                item.autolog
                                                                            "
                                                                            label="Auto Log..."
                                                                        ></v-textarea>

                                                                        <v-tooltip
                                                                            top
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    on,
                                                                                }"
                                                                            >
                                                                                <v-btn
                                                                                    @click="
                                                                                        doCopyLog(
                                                                                            item.autolog
                                                                                        )
                                                                                    "
                                                                                    style="margin-right:-15px; margin-top:-50px; float:right;"
                                                                                    small
                                                                                    v-on="
                                                                                        on
                                                                                    "
                                                                                    color="blue lighten-1"
                                                                                    fab
                                                                                >
                                                                                    <v-icon
                                                                                        color="white"
                                                                                        >mdi-content-copy</v-icon
                                                                                    >
                                                                                </v-btn>
                                                                            </template>
                                                                            <span
                                                                                >Copy
                                                                                Log</span
                                                                            >
                                                                        </v-tooltip>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-expansion-panel-content>
                                                        </v-expansion-panel>
                                                    </v-expansion-panels>
                                                </div>
                                            </template>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-row justify="center">
            <v-dialog
                v-model="dialog_history"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close_history()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="10" sm="5" md="3">
                                        <v-text-field
                                            v-model="search.search"
                                            label="Search"
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="10" sm="5" md="3">
                                        <v-autocomplete
                                            :items="data_history_branch"
                                            v-model="search.branch"
                                            item-text="branch_name"
                                            item-value="branch_id"
                                            label="Branch"
                                            dense
                                            outlined
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="10" sm="5" md="3">
                                        <v-menu
                                            v-model="modal_menu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateRangeText"
                                                    label="Date range"
                                                    readonly
                                                    dense
                                                    v-on="on"
                                                    outlined
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="search.date"
                                                range
                                                @change="get_date()"
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn
                                            :disabled="
                                                search.search == '' &&
                                                    search.date.length == 0 &&
                                                    search.branch == ''
                                            "
                                            rounded
                                            color="amber"
                                            @click="get_history()"
                                        >
                                            <v-icon small class="mr-1">
                                                mdi-magnify
                                            </v-icon>

                                            Search
                                        </v-btn>
                                        <v-btn
                                            :disabled="
                                                search.search == '' &&
                                                    search.date.length == 0 &&
                                                    search.branch == ''
                                            "
                                            x-small
                                            fab
                                            class="ml-1"
                                            @click="reset_history()"
                                        >
                                            <v-icon>mdi-rotate-left</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th
                                                            class="text-center"
                                                            width="3%"
                                                        >
                                                            #
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                            width="35%"
                                                        >
                                                            Case
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                            width="20%"
                                                        >
                                                            Site
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                            width="11%"
                                                        >
                                                            Engineer / Branch
                                                        </th>

                                                        <th
                                                            class="text-center"
                                                            width="11%"
                                                        >
                                                            Log
                                                        </th>

                                                        <th
                                                            class="text-center"
                                                            width="20%"
                                                        >
                                                            Log Note
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody
                                                    v-if="
                                                        data_history.length != 0
                                                    "
                                                >
                                                    <tr
                                                        v-for="(r,
                                                        i) in data_history"
                                                        :key="i"
                                                    >
                                                        <td>{{ i + 1 }}.</td>
                                                        <td>
                                                            <v-btn
                                                                class="mt-1 mb-1"
                                                                :to="
                                                                    '/Project/ViewCasepending/' +
                                                                        team_name +
                                                                        '/' +
                                                                        r.maincase_id +
                                                                        '/ViewDetail'
                                                                "
                                                                target="_blank"
                                                                small
                                                                color="white"
                                                                rounded
                                                            >
                                                                <span
                                                                    :class="
                                                                        r.case_id !=
                                                                            'return-pickup' &&
                                                                        r.case_id !=
                                                                            'return'
                                                                            ? 'primary--text mr-1'
                                                                            : 'green--text mr-1'
                                                                    "
                                                                >
                                                                    {{
                                                                        r.case_id
                                                                    }}
                                                                </span>

                                                                <span
                                                                    class="teal--text"
                                                                >
                                                                    {{
                                                                        r.wonumber
                                                                    }}</span
                                                                >
                                                            </v-btn>
                                                            <br />
                                                            <span
                                                                class="blue-grey--text font-b"
                                                            >
                                                                {{
                                                                    r.case_title
                                                                }}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {{ r.site_name }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                r.engineer_name
                                                            }}
                                                            <br />
                                                            <v-chip small>
                                                                {{
                                                                    r.branch_name
                                                                }}
                                                            </v-chip>
                                                        </td>

                                                        <td class="text-center">
                                                            {{ r.log_name }}
                                                            <br />
                                                            <v-chip small>
                                                                {{ r.log_date }}
                                                            </v-chip>
                                                        </td>

                                                        <td class="text-center">
                                                            {{ r.log_note }}
                                                        </td>
                                                    </tr>
                                                    <br />
                                                </tbody>
                                                <tbody v-else>
                                                    <tr>
                                                        <td
                                                            class="text-center"
                                                            colspan="6"
                                                        >
                                                            no results found
                                                        </td>
                                                        <br />
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- snackbar -->
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
import ViewCdax from "../../../components/ViewCdax"
export default {
    beforeMount() {
        this.token = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_zone()
    },
    components: {
        ViewCdax,
    },
    computed: {
        dateRangeText() {
            this.search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.search.date.join(" ~ ")
        },
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal_menu = false
            }
        },
        async get_dialog_history() {
            this.dialog_loading = true
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/get-branch-history`
            await axios
                .get(url, this.token)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_history_branch = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
            this.dialog_history = true
        },
        reset_history() {
            this.search.date = []
            this.search.search = ""
            this.search.branch = ""
            this.data_history = []
        },
        close_history() {
            this.dialog_history = false
            this.search.date = []
            this.search.search = ""
            this.search.branch = ""
            this.data_history = []
            this.data_history_branch = []
        },
        async get_history() {
            this.dialog_loading = true
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/view-history`
            await axios
                .post(url, this.search, this.token)
                .then((response) => {
                    this.dialog_loading = false
                    this.data_history = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_zone() {
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/get-zone`
            await axios.get(url, this.token).then((response) => {
                this.data_zone = response.data
                this.form_search.zone = "All"

                this.get_branch()
            })
        },
        async get_branch() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/get-branch`
            try {
                let { data } = await axios.post(
                    url,
                    {
                        zone: this.form_search.zone,
                    },
                    this.token
                )

                this.data_branch = data
                this.get_status()
            } catch (error) {
                console.log(error)
            }
        },
        async get_status() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/get-status`
            try {
                let { data } = await axios.post(
                    url,
                    {
                        zone: this.form_search.zone,
                        branch: this.form_search.branch,
                    },
                    this.token
                )

                this.all_sum = 0
                data.map((each) => {
                    this.all_sum += parseInt(each.num_cases)
                })
                this.data_status = data

                this.get_data("All")
            } catch (error) {
                console.log(error)
            }
        },
        async get_data(status, index) {
            if (status == "All") {
                this.chk_active_all = 1
                this.chk_active_btn = ""
                this.form_search.status = status
            } else {
                this.chk_active_btn = index
                this.chk_active_all = 0
                this.form_search.status = status
            }
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/view-all`
            try {
                let { data } = await axios.post(
                    url,
                    {
                        zone: this.form_search.zone,
                        branch: this.form_search.branch,
                        status: this.form_search.status,
                    },
                    this.token
                )

                this.data_table = data
            } catch (error) {
                console.log(error)
            }
        },
        reset() {
            this.form_search.zone = "All"
            this.form_search.branch = "All"
            this.form_search.status = "All"
            this.data_status = []
            this.panel = ""
            this.readviewcase = []
            this.get_status()
        },
        async viewdata(status, engineer, branch) {
            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/view-case`
            try {
                let { data } = await axios.post(
                    url,
                    {
                        ce_update_status: status,
                        engineer: engineer,
                        branch: branch,
                    },
                    this.token
                )
                this.row_branch_id = ""
                this.row_branch_id = branch
                this.data_view = []
                this.none()
                this.dialog = true
                this.data_view = data
                this.readviewcase = [0]
                this.panel = 0
            } catch (error) {
                console.log(error)
            }
        },
        all() {
            this.panel = i
            this.readviewcase = []
            for (let i = 0; i < this.data_view.length; i++) {
                this.readviewcase.push(i)
            }
        },
        // Reset the panel
        none() {
            this.panel = ""
            this.readviewcase = []
        },
        readcase(i) {
            if (this.readviewcase.indexOf(i) === -1) {
                this.readviewcase.push(i)
            }
        },
        doCopy(text) {
            navigator.clipboard.writeText(text)
        },
        doCopyLog(text) {
            navigator.clipboard.writeText(text)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },

        async save(status, engineer) {
            this.mutateIsLoading()

            let url = `${process.env.VUE_APP_ROOT_API}/api/ismart/save-case`
            try {
                let { data } = await axios.post(
                    url,
                    {
                        ce_update_status: status,
                        engineer: engineer,
                        branch_id: this.row_branch_id,
                    },
                    this.token
                )
                this.dialog = false
                this.mutateIsLoading()
                this.mutatesnackbar()
                setTimeout(() => {
                    this.mutatesnackbar()
                }, 3000)

                this.get_data(this.form_search.status, this.chk_active_btn)
            } catch (error) {
                this.mutateIsLoading()
                console.log(error)
            }
        },
    },

    data() {
        return {
            dialog_history: false,
            dialog_loading: false,
            modal_menu: false,
            data_history: [],
            data_history_branch: [],
            team_name: localStorage.team_name,
            readviewcase: [],
            panel: "",
            items: 5,
            token: "",
            data_zone: [],
            data_branch: [],
            data_status: [],
            data_table: [],
            data_view: [],
            form_search: {
                branch: "All",
                zone: "All",
                status: "All",
            },
            row_branch_id: "",
            chk_active_all: null,
            chk_active_btn: null,
            chk_load_data: false,
            dialog: false,
            showTooltip: false,
            text: "Success, Your work has been saved",
            all_sum: 0,
            search: {
                date: [],
                search: "",
                branch: "",
            },
        }
    },
}
</script>

<style scoped>
.fix-color {
    color: rgb(11, 53, 131) !important;
}
</style>
